document.addEventListener('DOMContentLoaded', initOrderConfirmedPage);

const ORDER_STORAGE_KEY = 'pepx_pending_order';

function initOrderConfirmedPage() {
  const root = document.querySelector('[data-order-confirmed-page]');
  if (!root) return;

  const configEl = root.querySelector('[data-order-confirmed-config]');
  const config = configEl ? JSON.parse(configEl.textContent) : {};
  const contentEl = root.querySelector('[data-order-confirmed-content]');
  const emptyEl = root.querySelector('[data-order-empty]');
  const itemsEl = root.querySelector('[data-order-items]');
  const shippingEl = root.querySelector('[data-order-shipping]');
  const totalsEl = root.querySelector('[data-order-totals]');
  const refEl = root.querySelector('[data-order-ref]');

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, config.moneyFormat);
    }
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function itemTitle(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return `${item.product_title || item.title} — ${item.variant_title}`;
    }
    return item.product_title || item.title || '';
  }

  function updateHeaderCount(count) {
    const bubbleBtn = document.getElementById('cart-icon-bubble');
    if (!bubbleBtn) return;

    let bubble = bubbleBtn.querySelector('.site-header__cart-count');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'site-header__cart-count';
        bubbleBtn.appendChild(bubble);
      }
      bubble.textContent = count;
      bubble.hidden = false;
    } else if (bubble) {
      bubble.remove();
    }

    if (window.CartDrawer && typeof window.CartDrawer.updateHeaderCount === 'function') {
      window.CartDrawer.updateHeaderCount(count);
    }
  }

  function showEmpty() {
    if (contentEl) contentEl.hidden = true;
    if (emptyEl) emptyEl.hidden = false;
  }

  function showContent() {
    if (contentEl) contentEl.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
  }

  function readStoredOrder() {
    try {
      const raw = sessionStorage.getItem(ORDER_STORAGE_KEY);
      if (!raw) return null;
      const order = JSON.parse(raw);
      if (!order || !Array.isArray(order.items) || !order.items.length) return null;
      return order;
    } catch {
      return null;
    }
  }

  function renderOrder(order) {
    const items = order.items || [];
    const attributes = order.attributes || {};
    const orderRef = order.orderRef || '';

    if (refEl && orderRef) {
      refEl.textContent = `Reference: ${orderRef}`;
      refEl.hidden = false;
    }

    if (itemsEl) {
      itemsEl.innerHTML = items
        .map((item) => {
          const title = escapeHtml(itemTitle(item));
          const image = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${title}" class="order-confirmed__item-image" loading="lazy">`
            : '<div class="order-confirmed__item-placeholder" aria-hidden="true"></div>';

          return `
            <article class="order-confirmed__item">
              <div class="order-confirmed__item-media">${image}</div>
              <div class="order-confirmed__item-body">
                <p class="order-confirmed__item-title">${title}</p>
                <p class="order-confirmed__item-meta">${formatMoney(item.final_price || item.price)} × ${item.quantity}</p>
              </div>
              <span class="order-confirmed__item-total">${formatMoney(item.line_price || (item.price || 0) * item.quantity)}</span>
            </article>`;
        })
        .join('');
    }

    if (shippingEl) {
      const fields = [
        ['Name', [attributes['First Name'], attributes['Last Name']].filter(Boolean).join(' ')],
        ['Email', attributes.Email],
        ['Phone', attributes.Phone],
        ['Country', attributes.Country],
        ['Address', attributes.Address],
        ['City', attributes.City],
        ['State', attributes.State],
        ['ZIP Code', attributes['ZIP Code']],
        ['Payment Method', attributes['Payment Method']]
      ].filter(([, value]) => Boolean(value && String(value).trim()));

      shippingEl.innerHTML = fields
        .map(
          ([label, value]) => `
            <div class="order-confirmed__detail-row">
              <dt>${escapeHtml(label)}</dt>
              <dd>${escapeHtml(value)}</dd>
            </div>`
        )
        .join('');
    }

    if (totalsEl) {
      totalsEl.innerHTML = `
        <div class="order-confirmed__total-row">
          <span>Subtotal</span>
          <span>${formatMoney(order.subtotal || 0)}</span>
        </div>
        <div class="order-confirmed__total-row order-confirmed__total-row--grand">
          <span>Total</span>
          <span>${formatMoney(order.total || 0)}</span>
        </div>`;
    }
  }

  async function clearCart() {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Failed to clear cart');
    const cart = await res.json();
    updateHeaderCount(cart.item_count || 0);
    return cart;
  }

  function getPreviewOrder() {
    return {
      orderRef: 'NL-PREVIEW',
      subtotal: 9900,
      total: 9900,
      currency: config.currency || 'USD',
      attributes: {
        'First Name': 'John',
        'Last Name': 'Doe',
        Email: 'john@example.com',
        Phone: '18084923911',
        Country: 'United States',
        Address: '123 Research Blvd',
        City: 'Boston',
        State: 'MA',
        'ZIP Code': '02101',
        'Payment Method': 'Cryptocurrency'
      },
      items: [
        {
          product_title: 'Sample Research Compound',
          title: 'Sample Research Compound',
          variant_title: '10mg',
          quantity: 2,
          price: 4950,
          final_price: 4950,
          line_price: 9900,
          image: ''
        }
      ]
    };
  }

  function isDesignMode() {
    return Boolean(config.designMode);
  }

  async function init() {
    let order = readStoredOrder();
    const preview = isDesignMode();

    if (!order && preview) {
      order = getPreviewOrder();
    }

    if (!order) {
      showEmpty();
      return;
    }

    renderOrder(order);
    showContent();

    if (!preview && window.MetaPixelEvents) {
      window.MetaPixelEvents.trackPurchaseOnce(order);
    }

    if (preview) return;

    try {
      await clearCart();
      sessionStorage.removeItem(ORDER_STORAGE_KEY);
    } catch {
      // Keep order visible even if cart clear fails.
    }
  }

  init();
}
